// removed by extract-text-webpack-plugin
module.exports = {"description":"_3RuARIUB-skl8rNIevFk1w","processNavbar":"_2RXIiYZpLW117KTp9axh7x","queryDataList":"_230Ys1CAjsf6ssKBdYd2SB","userDataList":"c9cMo2bczhVBIpZ_vybDY","queryStatus":"ybyCpG2iaasIncIRft-t9","userPhoto":"nIfrp49GCWX1vRvWqZ5sM","exclamation":"_21GVm4_87Es3WxrorXOPtw","text":"_3GS6DMx6iJx1OjyM7Pe4q"};


//////////////////
// WEBPACK FOOTER
// ./components/Transactions/styles.less
// module id = 1487
// module chunks = 0